import thumbnailFallback from '~/assets/imgs/thumbnail-fallback.jpg'

export mapBlogToSimpleCard = (blog) ->
	url: "/blogs/#{blog.slug}"
	headline: blog.title
	featuredImage: getBlogThumbnail(blog)
	size: "small"
	date: formatDate blog.dateCreated
	category: blog.blogCategories?[0]?.title
	cta: blog.cta
	readTime: blog.readTime
	thumbnailFocalPoint: getThumbnailFocalPoint(blog)

getBlogThumbnail = (blog) ->
	if blog.thumbnail?.length then return blog.thumbnail[0]
	if blog.highlightMedia?.length then return blog.highlightMedia[0]
	return thumbnailFallback

formatDate = (date) ->
	date = new Date(date)
	mm = String(date.getMonth() + 1).padStart(2, '0')
	dd = String(date.getDate()).padStart(2, '0')
	yyyy = date.getFullYear()

	return "#{mm}.#{dd}.#{yyyy}";

# Used to identify if we're using the migrated images from Medium as thumbnails
# Our cards are square ratio, and the original thumbnails were not, so we need to treat
# the differently
getThumbnailFocalPoint = (blog) ->
	if blog.thumbnail?.length then return 'center center'
	if blog.highlightMedia?.length then return 'center left'
	return 'center center'
